<template>
  <article class="card" :class="classes">
    <header class="card-header">
      <div class="card-header-left">
        <div class="card-header-title">
          {{ title }}
          <div class="tooltip-container">
            <i class="material-icons">&#xE88F;</i>
            <div class="tooltip tooltip-top" role="tooltip">
              <div class="tooltip-outer">
                <div class="tooltip-arrow"></div>
                <div class="tooltip-inner">{{ help }}</div>
              </div>
            </div>
          </div>
        </div>
        <p class="card-header-subtitle" v-if="subtitle">{{ subtitle }}</p>
      </div>

      <div class="card-header-right">
        <slot name="controls" v-if="!error || forceControls">
          <!-- [ CONTROLS ] -->
        </slot>
      </div>
    </header>

    <section class="card-content">
      <slot v-if="!error">
        <!-- [ CONTENT ] -->
      </slot>
      <error-state v-else :type="error"/>
    </section>
  </article>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    isLoading: Boolean,
    padded: String,
    rounded: String,
    error: String
  },

  computed: {
    title() {
      return this.$t(`${this.name}.title`);
    },

    subtitle() {
      const path = `${this.name}.subtitle`;
      return this.$te(path) ? this.$t(path) : "";
    },

    help() {
      return this.$t(`${this.name}.help`);
    },

    classes() {
      const classes = [];

      // name
      classes.push(this.name.replace(/[\W_]+/g, "-"));
      const name = this.name.split(".").pop();
      if (name) {
        classes.push(name.replace(/[\W_]+/g, "-") + "-card");
      }

      // states
      if (this.isLoading) {
        classes.push("is-loading");
      }
      if (this.$options.propsData.padded !== undefined) {
        classes.push("is-padded");
      }
      if (this.$options.propsData.rounded !== undefined) {
        classes.push("is-rounded");
      }
      if (this.$slots.controls) {
        classes.push("has-controls");
      }
      if (this.error) {
        classes.push("has-error");
        classes.push(
          "error-state-" + this.error.replace(/_/g, "-").toLowerCase()
        );
      }

      return classes;
    },

    forceControls() {
      return this.error === "no_timeline";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";

.content {
  position: relative;
  height: 100%;
}

.card.has-shadow {
  box-shadow: 0 2px 4px 0 rgba(black, 0.08);
}

.card-header-link {
  position: relative;
  color: rgba($black, 0.87);
  font-size: 0.625rem;
  font-weight: 500;
  letter-spacing: 2.1px;
  background-color: rgba($white, 0.8);
  padding: 4px 10px;
  border-radius: 2px;
  border: solid 0.5px rgba($black, 0.12);
  text-transform: uppercase;
  transition: $transition;

  &:hover,
  &:focus {
    background-color: $white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.02),
      0 2px 12px 0 rgba(0, 0, 0, 0.06);
  }

  .mdi {
    font-size: 0.625rem;
  }
}
</style>